// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';

// Set up global axios defaults
axios.defaults.headers.common['Content-Type'] = 'application/json';

// Add auth token from localStorage to axios defaults if exists
const token = localStorage.getItem('authToken');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// Add interceptor for handling 401 errors (expired tokens)
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      // Clear token and redirect to login
      localStorage.removeItem('authToken');
      delete axios.defaults.headers.common['Authorization'];
      
      // Only redirect if we're not already on an auth page
      const currentPath = window.location.pathname;
      if (!['/app/login', '/app/register', '/app/verify-email', '/app/verification-pending'].includes(currentPath)) {
        window.location.href = '/app/login';
      }
    }
    return Promise.reject(error);
  }
);

// Check if we're on an app path
const isAppPath = window.location.pathname.startsWith('/app');

// Ensure links to landing page cause a full page reload
document.addEventListener('click', (e) => {
  // Find if the clicked element is a link or is contained within a link
  let target = e.target;
  while (target && target.tagName !== 'A') {
    target = target.parentElement;
  }
  
  // If it's a link
  if (target && target.tagName === 'A') {
    const href = target.getAttribute('href');
    
    // If link points to root or other non-app paths
    if (href && !href.startsWith('/app') && !href.startsWith('http') && !href.startsWith('#')) {
      // Force a full page reload instead of letting React Router handle it
      e.preventDefault();
      window.location.href = href;
    }
  }
});

// Add event listener for back/forward navigation
window.addEventListener('popstate', (event) => {
  const newPath = window.location.pathname;
  const wasAppPath = isAppPath;
  const isNowAppPath = newPath.startsWith('/app');
  
  // If we're transitioning between app and non-app paths
  if (wasAppPath !== isNowAppPath) {
    // Force a full page reload
    window.location.reload();
  }
});

if (isAppPath) {
  // We're on an app path, render React
  const rootElement = document.getElementById('root');
  
  if (rootElement) {
    try {
      const root = ReactDOM.createRoot(rootElement);
      root.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>
      );
    } catch (error) {
      console.error('Failed to render React app:', error);
    }
  } else {
    console.error('Root element not found for React app');
  }
} else {
  // We're on a non-app path but React is loaded somehow
  // Redirect to ensure proper landing page loading
  if (document.referrer.includes('/app')) {
    window.location.reload();
  }
}

reportWebVitals();